<template>
  <img
    alt="Kairos Vista"
    height="40"
    src="/logo_kv3.svg"
    width="40"
  >
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
